import { reportsConstants } from "../../constants/client";

export const reports = {
  listing,
  listingSuccess,
  listingFailure,

  configListing,
  configListingSuccess,
  configListingFailure,

  configSave,
  configSaveSuccess,
  configSaveFailure,

  configDelete,
  configDeleteSuccess,
  configDeleteFailure
};

function listing(payload) {
  return { type: reportsConstants.LISTING_REQUEST, payload };
}

function listingSuccess(payload) {
  return { type: reportsConstants.LISTING_SUCCESS, payload };
}

function listingFailure(error) {
  return { type: reportsConstants.LISTING_FAILURE, error };
}

function configListing(payload) {
  return { type: reportsConstants.CONFIG_LISTING_REQUEST, payload };
}

function configListingSuccess(payload) {
  return { type: reportsConstants.CONFIG_LISTING_SUCCESS, payload };
}

function configListingFailure(error) {
  return { type: reportsConstants.CONFIG_LISTING_FAILURE, error };
}

function configSave(payload) {
  return { type: reportsConstants.CONFIG_SAVE_REQUEST, payload };
}

function configSaveSuccess(payload) {
  return { type: reportsConstants.CONFIG_SAVE_SUCCESS, payload };
}

function configSaveFailure(error) {
  return { type: reportsConstants.CONFIG_SAVE_FAILURE, error };
}


function configDelete(payload) {
  return {
    type: reportsConstants.CONFIG_DELETE_REQUEST,
    payload: { id: payload[0] } //currently only one item will be there in array
  };
}

function configDeleteSuccess(payload) {
  return { type: reportsConstants.CONFIG_DELETE_SUCCESS, payload };
}

function configDeleteFailure(error) {
  return { type: reportsConstants.CONFIG_DELETE_FAILURE, error };
}